export default "__VITE_ASSET__8c484d80__"